import api from '../../api/presentUserInfo';

const state = {
  profileData: {
    name: '',
    title: '',
    about: '',
    profile_image: '',
    website_link: '',
    facebook_link: '',
    instagram_link: '',
  },
  isLoading: false,
  uploadValue: 0,
};

const getters = {
  profileData: state => state.profileData,
  isLoading: state => state.isLoading,
  uploadValue: state => state.uploadValue,
};

const actions = {
  async fetchCurrentUserProfile({ rootState, commit }) {
    commit('setLoading', true);
    try {
      const { apptoken } = rootState.appauth;
      const response = await api.fetchCurrentUserProfile(apptoken);
      if (response.status === 200 && response.data) {
        commit('setProfileData', {
          name: response.data.name || '',
          title: response.data.title || '',
          about: response.data.about || '',
          profile_image: response.data.profile_image || '',
          website_link: response.data.website_link || '',
          facebook_link: response.data.facebook_link || '',
          instagram_link: response.data.instagram_link || '',
        });
      }
    } catch (error) {
      console.error('Error fetching user profile:', error);
      commit('setProfileData', {
        name: '',
        title: '',
        about: '',
        profile_image: '',
        website_link: '',
        facebook_link: '',
        instagram_link: '',
      });
    } finally {
      commit('setLoading', false);
    }
  },
  
  loadDefaultProfile({ commit }) {
    commit('setProfileData', {
      name: '',
      title: '',
      about: '',
      profile_image: '',
      website_link: '',
      facebook_link: '',
      instagram_link: '',
    });
  },
  
  async updateUserProfile({ rootState, commit, state }) {
    commit('setLoading', true);
    try {
      const { apptoken } = rootState.appauth;
      const response = await api.updateUserProfile(apptoken, state.profileData);
      if (response.status === 200 && response.data) {
        // Update profile data with response if needed
        if (response.data.ServerMassageCode === 'success') {
          commit('setProfileData', {
            name: response.data.name || state.profileData.name || '',
            title: response.data.title || state.profileData.title || '',
            about: response.data.about || state.profileData.about || '',
            profile_image: response.data.profile_image || state.profileData.profile_image || '',
            website_link: response.data.website_link || state.profileData.website_link || '',
            facebook_link: response.data.facebook_link || state.profileData.facebook_link || '',
            instagram_link: response.data.instagram_link || state.profileData.instagram_link || '',
          });
          return { success: true, message: response.data.message || 'הפרופיל עודכן בהצלחה' };
        } else {
          return { success: false, message: response.data.message || 'שגיאה בעדכון הפרופיל' };
        }
      }
      return { success: false, message: 'שגיאה בעדכון הפרופיל' };
    } catch (error) {
      console.error('Error updating user profile:', error);
      return { success: false, message: error.response?.data?.message || 'שגיאה בעדכון הפרופיל' };
    } finally {
      commit('setLoading', false);
    }
  },
};

const mutations = {
  setProfileData: (state, profileData) => {
    state.profileData = { ...profileData };
  },
  setProfileField: (state, { field, value }) => {
    state.profileData[field] = value;
  },
  setLoading: (state, isLoading) => {
    state.isLoading = isLoading;
  },
  setUploadValue: (state, uploadValue) => {
    state.uploadValue = uploadValue;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};

